import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { AsyncFormValidation } from '../../interceptors/error.interceptor';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RequestService } from '../request/request';
import { Address, AddressDTO } from '../../models/address.interface';
import { QueryGet } from '../../types/query-types';
import { Pagination } from '../../models/pagination.interface';
import { OptionSelect } from '../../../shared/components/search-select/search-select';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  httpOptions = {
    headers: new HttpHeaders({}),
  };

  urlPath = environment.service_1 + 'address/';
  url = environment.service_1 + 'all-address/';

  public asyncErrorValidation = new BehaviorSubject<AsyncFormValidation | null>(null);
  asyncErrorValidation$ = this.asyncErrorValidation.asObservable();

  private selectedaddress = new BehaviorSubject<Address | null>(null);
  selectedaddress$ = this.selectedaddress.asObservable();

  private addresses = new BehaviorSubject<Address[]>([]);
  addresses$ = this.addresses.asObservable();

  constructor(
    private http: HttpClient,
    private requestService: RequestService,
  ) {}

  setAddress(address: Address) {
    this.selectedaddress.next(address);
  }

  setAddresses(addresses: Address[]) {
    this.addresses.next(addresses);
  }

  removeAddressSelected() {
    this.selectedaddress.next(null);
  }

  createAddress(address: AddressDTO) {
    return this.http.post<Address>(this.urlPath, address).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  UpdateAddress(id: number, address: AddressDTO & { id: number }) {
    return this.http.put<Address>(this.urlPath + id + '/', address).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.asyncErrorValidation.next(err.error);
        },
      }),
    );
  }

  getAddress(query: QueryGet): Observable<Pagination<Address[]>> {
    return this.requestService.get<Address[]>(this.urlPath, query);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.urlPath + id + '/');
  }

  getAddresses(): Observable<Address[]> {
    return this.http.get<Address[]>(this.url, {
      headers: this.httpOptions.headers,
    });
  }

  getOptionAddress(line: Address[]): OptionSelect[] {
    return line.map((item: Address) => {
      return {
        value: item.id ?? '',
        label: item.street + ' - ' + item.territory,
      };
    });
  }
}
